<template>
  <div id="HistoryList">
    <template v-if="type==0&&list!=''">
      <div class="history_list" v-for="(item,index) in list" :key="index" >
        <div class="history_list_title">
          <div>{{item.AcceptTime|setTime}}</div>
        </div>
        <!-- 在仓未生成转运订单的商品列表 -->
        <div class="history_list_box historyTab">
          <div class="like_box item">
            <el-image class="like_img" :src="item.TitImg!='没有可上传的图片'?item.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
            <div class="item_title">
              <p class="line_txt2">{{item.Title}}</p>
              <span class="color_aoao">{{$t('base.arrivedOn')}} {{item.WarehouseTime|setTimeS}} <br>{{$t('alert.deliveredTo')}}</span>
            </div>
          </div>
          <!-- <div class="history_box itemPrice">{{areaSymbol}} {{item.Price}}</div> -->
          <div class="history_box quantity">{{item.QuantitySold}}</div>
          <div class="history_box estimatedStateTax">{{areaSymbol}} {{item.TaxPrice}}</div>
          <!-- <div class="history_box shipping_fee">{{item.PayPostageMoney|setExchange}}</div> -->
          <div class="history_box shippingFee">{{setExchange(item.RealPayPostageMoney)}}</div>
          <div class="history_box timeInWarehouse">
            <div :class="item.WarehouseDay>=20?'text_red':'text_greed'">{{item.WarehouseDay}}d</div>
          </div>
          <div class="history_box operate">
            <router-link :to="{path:'/mycardhobby/detail/'+item.OrderId}">{{$t('base.viewDetails')}}</router-link>
          </div>
        </div>
      </div>
    </template>
    <!-- 转运订单列表 -->
    <template v-if="type!=0">
      <div class="history_list_box warehouse_list" v-for="(item,index) in list" :key="index" >
        <div class="history_list_title">
          <div>{{item.CreateDate|setTime}}
            <span class="OrderNo">{{$t('colon.orderNumber')}}<i>{{item.OrderNo}}</i></span>
            <span class="OrderNo">{{$tc('base.ItemsTotal',item.OrderDetails.length,{ n: item.OrderDetails.length })}}</span>
          </div>
          <template v-if="item.itemPriceTotal">
            <div><span class="text_blue DownloadPurchaseDetails" @click="setPrompt(item._id)">{{$t('base.DownloadPurchaseDetails')}}</span></div>
          </template>
          
        </div>
        <div class="warehouse_commondity">
          <div class="head_box item">
            <div class="like_box" :class="{'hide':(i>2)}" v-for="(res,i) in item.OrderDetails" :key="i" >
              <div class="item flex">
              <el-image class="like_img" :src="res.TitImg!='没有可上传的图片'?res.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
              <div class="item_title">
                <p class="line_txt2">{{res.Title}}</p>
                <!-- <span v-if="item.OrderNo">{{$t('colon.orderNumber')}} {{item.OrderNo}}</span> -->
              </div>
              </div>
              <div class="head_box itemPrice">
                <!-- {{areaSymbol}} {{res.RealLowestPrice}} -->
                <template v-if="res.RealLowestPrice">
                  {{res.RealLowestPriceUnit}} {{res.RealLowestPrice}}
                </template>
                
                </div>
            </div>
            
            <div class="listItemsTotal">
              {{$tc('base.ItemsTotal',item.OrderDetails.length,{ n: item.OrderDetails.length })}}
            </div>
          </div>
          <!-- <div class="head_box commod">{{item.CreateDate|setTimeA}}</div> -->
          <!-- <div class="head_box item">{{item.CommondityAmount == 0 || item.CommondityAmount == null? '' : item.CommondityAmount}}</div> -->
          <div class="head_box weighed">{{item.Weight?item.Weight+'kg':$t('base.preparing')}}</div>
          <div class="head_box estimatedStateTax">
            <template v-if="item.itemPriceTotal">
              {{areaSymbol+' '+item.itemPriceTotal}}
            </template>
            </div>
          <div class="head_box orderInfo">
            <template v-if="item.RealTaxPrice||item.BuyMemberSource=='US'">
              <div>{{$t('base.stateTax')}}  {{(item.RealTaxPrice&&item.RealTaxPrice>0)?item.RealOrderPriceUnit+' '+item.RealTaxPrice:'/'}}</div>
            </template>
            <div>{{$t('base.internationalShippingFee')}} <span :class="{'text_gray':(item.Status==0)}">{{item.Status==0?$t('base.preparing'):item.RealOrderPriceUnit+' '+item.RealPostageMoney}}</span></div>
            <div>{{$t('base.cardhobbyPay')}} {{(item.RealPayPostageMoney&&item.RealPayPostageMoney>0)?item.RealOrderPriceUnit+' '+item.RealPayPostageMoney:'/'}}</div>
            <div class="text_blue" v-if="item.Status>0">{{$t('base.AmountDue')}} <span class="weight_700">{{item.RealOrderPriceUnit+' '+item.RealOrderPrice}}</span></div>
            <template v-if="item.Status === 1">
              <div>
                <div class="history_txt history_btn" @click="BuyItNow(item)">{{$t('base.pay')}}</div>
              </div>
            </template>
            <template v-if="item.Status === 3">
              <div>
                <div class="history_txt history_btn"  @click="SetReceive(item)">{{$t('base.confirmItem')}}</div>
              </div>
            </template>
            <div>
              <router-link class="history_txt" :to="{path:'/mycardhobby/waredetail/'+item._id}">{{$t('base.viewDetails')}}</router-link>
            </div>
            <!-- <div class="history_txt"  @click="dialog(item,'view')">{{$t('base.viewDetails')}}</div> -->
          </div>
        </div>
        <!-- <div class="listItemsTotal">
          {{$tc('base.ItemsTotal',item.OrderDetails.length,{ n: item.OrderDetails.length })}}
        </div> -->
      </div>
    </template>
    <ware-house :dom="dislogType.warehouse" :item="item" @closeDialog="closeDialog" v-if="dislogType.warehouse" />
  </div>
</template>
<script>
import { setUTC, getTime,numMulti, priceExchange, getAreaForSymbol,prompt} from "@/api/public";
import WareHouse from "@/components/dialog/warehouse"; // 详情
export default {
  name: 'historylist',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      dialogBox: 'dialogBoxWarehouse',
      dialogVisible: false,
      dislogType: this.$enumInfo.dislogType,
      dialogList: '',
      item: '' //轉運倉當前選中訂單
    }
  },
  components: {
    WareHouse
  },
  filters: {
    setAddress(val) {
      let add = val.AddressDetail;
      let add1 = val.AddressDetail;
      // add1 = add1.replace(")", "")
      // add1 = add1.replace("(", "|")
      // add1 = add1.split("|")
      // add.AddressDetail = add1[1] && add1[1] != '' ? add1[0] + add1[1] : add1[0]
      return add
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimeA(val) {
      return getTime(val, -8, 2, 'cn')
    },
    setTimeS(val) {
      return getTime(val, -8, 1, 'cn')
    }
  },
  props: {
    list: {},
    type: 0,
    userInfo: {}
  },
  created() {
    if (this.type != 0) {
      this.areaSymbol = this.list?this.list[0].RealOrderPriceUnit:'USD'
    }
  },
  methods: {
    setPrompt(orderId){
      try{
        prompt(orderId);
      }catch(e){
        console.log(e)
      }
    },
    setNumMulti(val,val2){
      let num=0
      num=numMulti(val,val2)
      return num.toFixed(2)
    },
    getExpress(obj, val) {
      let text = ''
      if (val == 'name') {
        text = obj.ExpressName ? obj.ExpressName : ''
        if (obj.SecondExpressCode) {
          text = obj.SecondExpressName
        }
      }
      if (val == 'code') {
        text = obj.Express ? obj.Express : ''
        if (obj.SecondExpressCode) {
          text = obj.SecondExpress
        }
      }
      return text
    },
    setExchange(val) {
      var num = val
      if (num > 0 && num != null) {
        // num = '$ ' + priceExchange(num, 'USD')
        num = this.areaSymbol + ' ' + num
      } else {
        num = '/'
      }
      //&&item.PayPostageMoney>0 && item.PayPostageMoney!=null ? '$ '+item.PayPostageMoney:'/'
      return num
    },
    BuyItNow(obj) {
      let data = { AddressId: '', Details: '' };
      window.sessionStorage.setItem('check', JSON.stringify(data))
      this.$router.push({
        path: '/pay/warehouse/' + obj._id
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    dialog(obj, val) {
      let that = this;
      that.item = obj;
      that.dislogType.warehouse = true
      //console.log(obj._id)
      let data = { Id: obj._id }
      // this.$get(this.$interface.GetOrderById, data).then(res => {
      //   if (res.Result != 0) {
      //     that.dialogVisible = true
      //     let add = res.Data.Address.AddressDetail
      //     let add1=res.Data.Address.AddressDetail
      //     if(add1.indexOf('()')>0){
      //       // var a=add1.indexOf('()')
      //       // console.log(add1,a,'add2',add1.substring(0,a))
      //       //var reg=new RegExp()
      //       add1 = add1.replace(/\(\)/g, "")
      //       //console.log(add1,a,'add1')
      //       res.Data.Address.AddressDetail=add1
      //     }else{
      //       add1 = add1.replace(")", "")
      //       add1 = add1.replace("(", "|")
      //       add1 = add1.split("|")
      //       res.Data.Address.AddressDetail=add1[1]&&add1[1]!='' ? add1[0]+' '+add1[1] : add1[0]
      //     }
      //     that.dialogList = res.Data
      //   } else {
      //     this.$message({
      //       type: 'error',
      //       message: res.Msg
      //     });
      //   }
      //   console.log(res)
      // })
    },
    // 订单确认收货
    SetReceive(obj, type) {
      let that = this
      if (type) {
        let data = { Id: obj._id, Uid: that.userInfo.MappingUserId, UserName: that.userInfo.NickName }
        that.$post(that.$interface.CompleteOrderById, data).then(res => {
          if (res.Result == 1) {
            that.$parent.HistoryTabs(3)
          } else {
            that.$message({
              type: 'error',
              message: res.Msg
            });
          }
        })

      } else {
        that.$confirm('<div class="confirmData">' + that.$t('alert.ReceivingWarn1') + '</div>', that.$t('base.confirmItem'), {
          confirmButtonText: that.$t('base.confirm'),
          cancelButtonText: that.$t('base.cancel'),
          customClass: "confirmBox",
          lockScroll: false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          that.SetReceive(obj, 1)
        }).catch(() => {
          //this.handleClose()
          //this.closeDialog('confirm', false)
        });
      }
    }

  },
  //离开页面后清除定时器
  destroyed() {}
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";
@import "../../../static/css/warehouse.css";

.history_list_box .like_box {
  /* width: 440px; */
  width: auto;
}

.history_list_box .warehouse {
  /* width: 165px; */
  width: 144px;
  text-align: center;
}

.history_list_box .like_box .item_title {
  /* width: 350px; */
  flex:1;
  position: relative;
}

.item_title span {
  display: block;
  font-size: 12px;
  position: absolute;
  bottom: 0;
}

.history_list_box .like_box p {
  width: 100%;
}

.warehouse_list {
  display: flex;
  /* background-color: #f7f7f7; */
  min-height: 46px;
  line-height: 46px;
  margin: 12px 0;
  align-items: center;
  flex-direction: column;
}
.warehouse_list .history_list_title{
  margin-bottom: 10px;
}
.warehouse_commondity{
  display: flex;
  width: 100%;
}

.warehouse_list .like_box+.like_box {
  margin-top: 10px;
}

.shipping_fee_list .head_box {
  width: 110px;
  padding: 0 12px;
  text-align: center;
}





.dialogBoxWarehouse .detailPadding {
  margin: 0 20px;
  justify-content: space-between;
}

.detailPadding .like_box {
  width: 50%;
}

.detailPadding .like_detail {
  width: 76%;
  padding-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.detailPadding .like_detail>span {
  font-size: 12px;
  color: #a0a0a0;
}

.detailPadding .like_box p {
  padding: 0;
  width: 100%;
}

.detailPadding .price_house {
  width: 150px;
  color: #a0a0a0;
  text-align: center;
}

/* .detailPadding .price_house_list {
  width: 80%;
  margin: 5px auto;
} */
/* 
.detailPadding .price_house_list span {
  width: 50%;
  display: inline-block;
} */
.price_house_list {
  text-align: center;
}

.detailPadding .history_txt {
  width: 150px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: auto;
}

.history_txt {
  color: #5f6dae;
  line-height: 2;
}

.Items_info {
  line-height: 24px;
  font-size: 18px;
  margin: 25px -4px 25px;
  color: #333;
}

.detailPaddingUL li {
  display: flex;
  margin-bottom: 12px;
}

.detailPaddingUL li:last-child {
  margin: 0 0 25px 0;
}

.detailPaddingUL li span:first-child {
  color: #a0a0a0;
  /* width: 25%; */
  width: 201px;
  margin-right: 18px;
}

.itprice {
  /* width: 195px; */
  width: 112px;
  /* padding-right: 40px; */
}

.tracking {
  width: 116px;
  /* width: 160px; */
}

.overflowY {
  max-height: 350px;
  overflow-y: auto;
}

.its_Operate {
  display: flex;
}

.its_Operate div {
  width: 150px;
  text-align: center;
}

.its_Operate_2 {
  padding-right: 12px;
}

.history_list_title {
  justify-content: space-between;
  padding-left: 12px;
  width: 100%;
  color: #a0a0a0;
}

/deep/ .el-dialog__body {
  padding: 13px 20px 8px;
}

.history_list_title>div {
  padding: 0;
}

.history_txt.text_gray:hover,
.history_txt.text_gray {
  color: #a0a0a0;
  text-decoration: none;
  cursor: no-drop;
}



.OrderNo{
  margin-left: 10px;
}
.orderInfo>div+div{
  margin-top: 14px;
}
.listItemsTotal{
  width: 100%;
  color: #a0a0a0;
  margin-top: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/list/warehouse.vue